import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Text } from 'src/Components'
import styles from './Section.module.scss'

const Heading = ({ children, className }) => (
  <Text
    element='h2'
    size='l'
    variant='neutralCool'
    variantCount='900'
    weight='bold'
    align='left'
    className={classnames(styles.heading, className)}
  >
    {children}
  </Text>
)

const Body = ({ children, className }) => (
  <div className={classnames(styles.body, className)}>{children}</div>
)

const Divider = () => <hr className={styles.divider} />

const Section = ({ children, className }) => {
  const sections = {
    heading: null,
    body: null,
  }

  React.Children.forEach(children, child => {
    if (!child) return
    switch (child.type) {
      case Heading: {
        sections.heading = child
        break
      }
      case Body: {
        sections.body = child
        break
      }
      default:
        break
    }
  })

  return (
    <div className={className}>
      {sections.heading}
      {sections.body}
    </div>
  )
}

Heading.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

Heading.defaultProps = {
  className: '',
}

Body.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

Body.defaultProps = {
  className: '',
}

Section.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

Section.defaultProps = {
  className: '',
}

export default Object.assign(Section, {
  Heading,
  Body,
  Divider,
})
